import React from 'react';
import EArchiveGroupToolbar from './EArchiveGroupToolbar';
import { useSelectUsersContext } from '../../Services/SelectUsersContext';
import { GroupDetailListContent } from '../../Enums/GroupDetailListContent.enum';
import { useGroupsContext } from '../../Services/GroupsContext';
import useNotification from '../../../../Hooks/useNotification.hook';
import useApiClient from '../../../Base/Hooks/useApiClient';
import apiClient from '../../../../Services/ApiClient';
import useJob from '../../../Base/Hooks/useJob';

interface Props {
	groupId: string;
}

const EArchiveRemoveMembersFromGroupToolbar = ({ groupId }: Props) => {
	const { stopSelectingUsers, userIds } = useSelectUsersContext();
	const { setGroupDetailListContent } = useGroupsContext();
	const { showNotificationSuccess, showNotificationAlert } = useNotification();
	const { displayError, showUnexpectedError } = useApiClient();
	const { RenderJobWaiting, handleStartWaitingForJob } = useJob();

	const onCancel = () => {
		stopSelectingUsers();
		setGroupDetailListContent(GroupDetailListContent.MEMBERS);
	};

	const onSubmit = async () => {
		try {
			if (!userIds.length) {
				return showNotificationAlert({
					content: 'component.eArchive.group.members.atLeastOneMember',
				});
			}

			const response = await apiClient.delete(`/group/${groupId}/member/bulk`, {
				data: { userIds },
			});

			if (response?.status === 200) {
				const jobId = response?.data;
				return jobId ? handleStartWaitingForJob(jobId) : showUnexpectedError();
			}

			showUnexpectedError();
		} catch (error) {
			displayError(error);
		}
	};

	const onJobSuccess = () => {
		showNotificationSuccess({
			content: 'component.eArchive.group.members.removeMembersSuccess',
		});
		onCancel();
	};

	return (
		<>
			<EArchiveGroupToolbar
				onSubmit={onSubmit}
				onCancel={onCancel}
				submitText={'base.shared.form.send'}
				cancelText={'base.shared.cancel'}
			/>
			<RenderJobWaiting
				onJobSuccess={onJobSuccess}
				onJobSkipWaiting={onCancel}
				waitingMessage='component.eArchive.group.members.removeMembersWaiting'
				failedMessage='component.eArchive.group.members.removeMembersFail'
			/>
		</>
	);
};

export default EArchiveRemoveMembersFromGroupToolbar;
